var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgExternalReport = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 21C3 21.8284 3.67157 22.5 4.5 22.5H9V24H4.5C2.84315 24 1.5 22.6569 1.5 21V3C1.5 1.34315 2.84315 0 4.5 0H13.7295C14.5437 0.000191274 15.3245 0.323948 15.9 0.9L20.127 5.133C20.6862 5.6924 21.0002 6.45104 21 7.242V10.5H19.5V7.236C19.4989 6.84208 19.342 6.4646 19.0635 6.186L14.835 1.9575C14.5418 1.66442 14.1441 1.49985 13.7295 1.5H4.5C3.67157 1.5 3 2.17157 3 3V21ZM4.5 4.5H6V19.5H4.5V4.5ZM7.5 6V7.5H12V6H7.5ZM7.5 10.5H15V9H7.5V10.5ZM7.5 13.5V12H12V13.5H7.5ZM15 13.5V15H19.9395L12.219 22.719L13.281 23.781L21 16.0605V21H22.5V13.5H15ZM10.5 15H7.5V16.5H10.5V15Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgExternalReport);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/external-report.f55c43d17d2a93f7718721e7895e5cdf.svg";